module.exports = __webpack_public_path__ + "img/workspace-onboarding/record-a-video-611e6de1b21b2c44e9a56a0ec9b82faa.png";